import { render, staticRenderFns } from "./TasPolicyCancel.vue?vue&type=template&id=49d38132&scoped=true&"
import script from "./TasPolicyCancel.vue?vue&type=script&lang=js&"
export * from "./TasPolicyCancel.vue?vue&type=script&lang=js&"
import style0 from "./TasPolicyCancel.vue?vue&type=style&index=0&id=49d38132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d38132",
  null
  
)

export default component.exports